import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { GlobalStore } from 'src/app/store/global-store';
import { ManipulationsToolbarStore } from 'src/app/store/manipulations-toolbar-store';
import { environment } from 'src/environment';
@Component({
    selector: 'que-grid-header',
    imports: [CommonModule, TranslateDirective, TranslatePipe],
    templateUrl: './grid-header.component.html',
    styleUrls: ['./grid-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class GridHeaderComponent {
  @Input()
  isByFolders = false;
  isRoleAdmin$ = toSignal(inject(GlobalStore).isRoleAdmin$);
  #manipulationStore = inject(ManipulationsToolbarStore);
  isDisplayUser$ = toSignal(this.#manipulationStore.isDisplayUser$)
  isGeneralQuestionnaires$ = toSignal(this.#manipulationStore.isGeneralQuestionnaires$)
  isMyQuestionnaires$ = toSignal(this.#manipulationStore.isMyQuestionnaires$)
  isExpenseEnv = environment.featurs.expense;
}
